import { HighlightStyle, syntaxHighlighting, defaultHighlightStyle } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';
const darkThemeOverrides = HighlightStyle.define([
    { tag: [t.keyword, t.local(t.variableName)], class: 'cmt-keyword' },
    {
        tag: [t.atom, t.bool, t.url, t.contentSeparator, t.labelName, t.definition(t.variableName), t.definition(t.propertyName)],
        class: 'cmt-name',
    },
    { tag: [t.className, t.special(t.variableName), t.macroName], class: 'cmt-class' },
    { tag: [t.string, t.deleted, t.regexp, t.escape, t.special(t.string)], class: 'cmt-string' },
    { tag: [t.literal, t.inserted], class: 'cmt-literal' },
    { tag: [t.typeName, t.namespace], class: 'cmt-type' },
]);
export const codeHighlighting = [syntaxHighlighting(defaultHighlightStyle), syntaxHighlighting(darkThemeOverrides)];
